export const newFeatures = {
    collection: {
        level: 'レベル',
        fix_time: '修正回数：',
        earn_exercise: '運動ごとの獲得：',
        on_selling: '販売中',
        sell: '売る',
        edit: '編集',
        buy: '買う',
        stop: '停止',
        cancel: 'キャンセル',
        update: '更新',
        search: '検索',
    },
    sort_filter: {
        sort_by: '並べ替え',
        filter: 'フィルター',
        status: 'ステータス',
        sell_in: '販売期間',
        class: 'クラス',
        sale_hight: '最新の販売',
        sale_low: '新しい順',
        level_hight: 'レベル：高い順',
        level_low: 'レベル：低い順',
        reward_hight: '報酬：高い順',
        reward_low: '報酬：低い順',
        fix_time_hight: '修正回数：高い順',
        fix_time_low: '修正回数：低い順',
        radio_1: '獲得可能',
        radio_2: '修正が必要',
        radio_3: '販売中',
        clear_all: '全てクリア',
    },
    modal_sell: {
        fee: '販売注文が成功した場合、価値の%{fee}（約%{value}）を受け取ります。',
        sell_nft: 'NFTを販売する',
        edit_nft: 'NFTを編集する',
        buy_nft: 'NFTを購入する',
        stop_sell: '販売を停止する',
        want_sell_in: '販売したい場合',
        want_buy: 'このNFTを購入しますか？',
        want_stop: '販売を停止しますか？',
        code_2fa: '2FAコード',
    },
    tab_leaf: {
        payment: '支払い',
        total_amount: '合計金額',
        quantity: '数量',
        pay: '支払う',
        balance: '残高',
        limitMessage: '現在の残高では不十分です!',
        you_have: '所持数：',
        leaf: ' リーフ',
    },
    transaction: {
        transaction_history: '取引履歴',
        type: 'タイプ',
        item_id: 'アイテムID',
        tier: 'ティア',
        level: 'レベル',
        price: '価格',
        token: 'トークン',
        seller_buyer: '販売者/購入者',
        time: '時間',
        filter: 'フィルター',
        send: '送る',
    },
    common: {
        price: '価格',
        noData_market: '検索に一致するNFTはありません',
        edit: '編集',
        no_transaction: '取引はありません.',
        all: 'すべて',
        buy: '購入',
        sell: '販売',
        sent: '送信',
        receive: '受信',
        connect: '接続する',
        amount: '量',
        leaves: '葉',



    },
    tab_ticket: {
        ticket: ' チケット'
    },
};
